import {
  Input,
  Form,
  Divider,
  Radio,
  Switch,
  Slider,
  Select,
  Row,
  Col,
  InputNumber,
  Checkbox,
} from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import { ColorPickerFormItem, LandingPageList, getContentIDList } from "../Image/ImageConf";
import {
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
} from "@ant-design/icons";
import { BORDER_OPTIONS } from "../constanst";
import { useEditorContext } from "../EditorContext";
import ImageUpploadField from "../WechatTextImage/ImageUploadField";
import TrimmedInput from "../FormCommonField/FormTrimmedInput";


export default ({ node }) => {
  const defalutLabel = node?.data?.label || ""
  const { shareRefs } = useEditorContext();

  return (
    <>
      <Form.Item label="Label" name="label" rules={[{ required: true }]}>
      <TrimmedInput/>
      </Form.Item>
      <Form.Item label="Action" name="action" rules={[{ required: true }]}>
        <Select
          options={[
            { label: "Submit", value: "submit" },
            { label: "Reset", value: "reset" },
          ]}
        />
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const action = getFieldValue("action");
          if (action === "submit") {
            return (
              <Form.Item
                label="Submit success action"
                name="submitedAction"
              >
                <Radio.Group
                  options={[
                    { label: "Url", value: "redirectUrl" },
                    { label: "Landing page", value: "landing"},
                    { label: "Section", value: "contentBlock" },
                  ]}
                  defaultValue="center"
                  optionType="button"
                />
              </Form.Item>
            );
          }
          return null;
        }}
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const action = getFieldValue("action");
          const submitAction = getFieldValue("submitedAction");
          if (action === "submit") {
            if (submitAction === "redirectUrl") {
              return (
                <Form.Item
                  label="Submited form redirect url"
                  rules={[{ required: true, type: "url" }]}
                  name="submitedRedirectUrl"
                >
                  <Input type="url" />
                </Form.Item>
              );
            } else if (submitAction === "landing") {
              return (<LandingPageList rules={[{ required: true }]} />);
            } else if (submitAction === "contentBlock") {
              const contentIDList = getContentIDList(shareRefs.tree);
              return (
                <Form.Item rules={[{ required: true }]} label="Section" name={"contentBlock"}>
                  <Select options={contentIDList} />
                </Form.Item>
              );
            }
          }
          return null;
        }}
      </Form.Item>
      <strong>Style</strong>
      <Divider style={{ margin: "12px 0" }} />
      <div style={{ display: "flex", gap: 10 }}>
        <label>Auto width</label>
        <Form.Item noStyle valuePropName="checked" name={"autoWidth"}>
          <Switch />
        </Form.Item>
      </div>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const auto = getFieldValue("autoWidth");
          if (!auto) {
            return (
              <Form.Item noStyle name="width">
                <Slider
                  style={{ width: "90%" }}
                  min={20}
                  max={100}
                  marks={{ 20: "-", 100: "+" }}
                  tipFormatter={(v) => `${v}%`}
                />
              </Form.Item>
            );
          }
          return null;
        }}
      </Form.Item>
      <Form.Item label="Alignment" name="align">
        <Radio.Group
          options={[
            { label: <AlignLeftOutlined />, value: "left" },
            { label: <AlignCenterOutlined />, value: "center" },
            { label: <AlignRightOutlined />, value: "right" },
          ]}
          defaultValue="center"
          optionType="button"
        />
      </Form.Item>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="fontSize" label="Label font size">
            <InputNumber
              defaultValue={14}
              min={0}
              max={100}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="fontWeight" label="Label font weight">
            <Select
              defaultValue={"normal"}
              options={[
                { label: "Lighter", value: "lighter" },
                { label: "Normal", value: "normal" },
                { label: "Bold", value: "bold" },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <ColorPickerFormItem
            label={"Label color"}
            name="labelColor"
            color={node.data.textColor || { r: 0, g: 0, b: 0, a: 1 }}
          />
        </Col>
        <Col span={12}>
          <Form.Item name="borderWidth" label="Border width">
            <InputNumber
              defaultValue={1}
              min={0}
              max={100}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name={"borderStyle"} label="Border Style">
            <Select options={BORDER_OPTIONS} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="borderRadius" label="Border radius">
            <InputNumber
              defaultValue={0}
              min={0}
              max={100}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <ColorPickerFormItem
            label={"Border color"}
            name="borderColor"
            color={node.data.borderColor || { r: 0, g: 0, b: 0, a: 1 }}
          />
        </Col>
        <Col span={12}>
          <ColorPickerFormItem
            label={"Background color"}
            name="backgroundColor"
            color={node.data.backgroundColor || { r: 0, g: 0, b: 0, a: 1 }}
          />
        </Col>
      </Row>
      <label>Background image</label>
      <ImageUpploadField name="backgroundImage" />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: 8,
          justifyContent: "space-between",
        }}
      >
      <Form.Item
        noStyle
        valuePropName="checked"
        name={"fitToBackground"}
      >
        <Switch size="small" />
      </Form.Item>
      <label style={{ marginLeft: 5 }}>Fit to background</label>
      <div style={{ width: 30 }} />
      <Form.Item
        noStyle
        shouldUpdate={(prev, curr) =>
          prev.fitToBackground !== curr.fitToBackground
        }
      >
        {({ getFieldValue, setFieldValue }) => {
          const fitBg = getFieldValue("fitToBackground");
          if (fitBg) {
            setTimeout(() => {
              setFieldValue("repeatBackgroundImage", false);
              setFieldValue("centerBackgroundImage", false);
            });
          }
          return (
            <>
              <Form.Item
                noStyle
                name="repeatBackgroundImage"
                valuePropName="checked"
              >
                <Checkbox disabled={fitBg}>Repeat</Checkbox>
              </Form.Item>
              <Form.Item
                noStyle
                name="centerBackgroundImage"
                valuePropName="checked"
              >
                <Checkbox disabled={fitBg}>Center</Checkbox>
              </Form.Item>
            </>
          );
        }}
      </Form.Item>
      </div>
      <div style={{ height: 11 }} />
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "space-between",
        }}
      >
      </div>
      
      <ContentPadding />
    </>
  );
};
